import React, { useState, useEffect } from 'react';
import { FaStar, FaQuoteRight, FaChevronDown, FaWallet, FaClock, FaRocket, FaShieldAlt, FaMobileAlt, FaHandshake } from 'react-icons/fa';
import axios from 'axios';
import { API_URL } from '../config/apiConfig';
import './Drivers.css';

// Import images
import cabBgImage from '../assets/images/cab-bg.png';

// Custom components
import TestimonialSection from "../components/TestimonialSection";

const Drivers = () => {
  const [heroImage, setHeroImage] = useState(cabBgImage);
  const [formData, setFormData] = useState({
    companyName: '',
    email: '',
    mobile: '',
    address: '',
    city: '',
    state: '',
    pincode: ''
  });

  useEffect(() => {
    fetchHeroImage();
  }, []);

  const fetchHeroImage = async () => {
    try {
      const response = await axios.get(`${API_URL}/auth-images`, {
        params: { type: 'driver_page_hero', isActive: true }
      });
      if (response.data.success && response.data.data.length > 0) {
        setHeroImage(response.data.data[0].imageUrl);
      }
    } catch (error) {
      console.error("Error fetching driver hero image:", error);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    alert('Registration submitted successfully! We will contact you soon.');
  };

  return (
    <div className="drivers-page">
      {/* RESTORED OLD HERO SECTION */}
      <div className="hero-banner-image" style={{ backgroundImage: `url(${heroImage})` }}>
        <div className="banner-overlay"></div>
      </div>

      <section className="hero-content-wrapper">
        <div className="max-w-[1180px] mx-auto px-4">
          <div className="hero-grid-layout">
            <div className="hero-left-column">
              <div className="hero-text-new">
                <h1>Join <span className="text-blue">Cab</span><span className="text-orange">zigo</span> Taxi service Start Earning Now !!!</h1>
                <p className="subtitle-text">By Attaching Your Car with CabZigo</p>
                <p className="desc-text">
                  Increase you're earning Attach your car and make the most of your resources, avail the best offers in the industry, experience the cutting edge technology and start earning bigger than ever of course with the largest growing network of active riders.
                </p>
              </div>

              <div className="feature-item-new">
                <h3>Cash out fast in your account</h3>
                <p>
                  It's easy to get paid. All you need is a bank account. Your earnings are transferred every week to your account.
                </p>
              </div>
            </div>

            <div className="hero-right-column">
              <div className="registration-card">
                <h2>Register Now</h2>
                <form onSubmit={handleSubmit}>
                  <div className="form-group">
                    <input type="text" name="companyName" placeholder="Company Name" value={formData.companyName} onChange={handleChange} required />
                  </div>
                  <div className="form-group">
                    <input type="email" name="email" placeholder="Enter Email Id" value={formData.email} onChange={handleChange} required />
                  </div>
                  <div className="form-group">
                    <input type="tel" name="mobile" placeholder="Enter Mobile Number" value={formData.mobile} onChange={handleChange} required />
                  </div>
                  <div className="form-group">
                    <input type="text" name="address" placeholder="Address" value={formData.address} onChange={handleChange} required />
                  </div>
                  <div className="form-group">
                    <select name="city" value={formData.city} onChange={handleChange} required>
                      <option value="">Select Your City</option>
                      <option value="Rajkot">Rajkot</option>
                      <option value="Ahmedabad">Ahmedabad</option>
                      <option value="Surat">Surat</option>
                      <option value="Vadodara">Vadodara</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <input type="text" name="state" placeholder="State" value={formData.state} onChange={handleChange} required />
                  </div>
                  <div className="form-group">
                    <input type="text" name="pincode" placeholder="Pincode" value={formData.pincode} onChange={handleChange} required />
                  </div>
                  <button type="submit" className="submit-btn-old">Submit</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* NEW REDESIGNED FEATURES SECTION */}
      <section className="features-container">
        <div className="section-header">
          <h2>Why Partner with CabZigo?</h2>
          <p>We provide the tools and support you need to succeed in the modern professional driving industry.</p>
        </div>

        <div className="features-grid">
          <div className="feature-card">
            <div className="icon-box"><FaWallet /></div>
            <h3>Weekly Settlements</h3>
            <p>Get your earnings transferred directly to your bank account every week without any delays.</p>
          </div>
          
          <div className="feature-card">
            <div className="icon-box"><FaClock /></div>
            <h3>Flexible Hours</h3>
            <p>You are your own boss. Choose when you want to drive and how much you want to earn.</p>
          </div>

          <div className="feature-card">
            <div className="icon-box"><FaShieldAlt /></div>
            <h3>Safety First</h3>
            <p>24/7 dedicated support and in-app emergency features for your complete peace of mind.</p>
          </div>

          <div className="feature-card">
            <div className="icon-box"><FaRocket /></div>
            <h3>Modern Interface</h3>
            <p>Our cutting-edge app makes it easy to find rides and navigate to your destinations.</p>
          </div>

          <div className="feature-card">
            <div className="icon-box"><FaMobileAlt /></div>
            <h3>Best Technology</h3>
            <p>Advanced routing and rider matching technology to minimize empty miles and maximize pay.</p>
          </div>

          <div className="feature-card">
            <div className="icon-box"><FaHandshake /></div>
            <h3>Partnership</h3>
            <p>We believe in growing together. Avail the best insurance and maintenance offers in the industry.</p>
          </div>
        </div>
      </section>

      {/* NEW REDESIGNED STEPS SECTION */}
      <section className="how-it-works">
        <div className="section-header">
          <h2>Simple 3-Step Onboarding</h2>
          <p>Getting started is quick and easy. Follow these steps to join us.</p>
        </div>

        <div className="steps-grid">
          <div className="step-item">
            <div className="step-number">1</div>
            <h3>Register Online</h3>
            <p>Fill out our simple partnership form with your basic details.</p>
          </div>
          
          <div className="step-item">
            <div className="step-number">2</div>
            <h3>Verification</h3>
            <p>Our team will review your documents and verify your vehicle details.</p>
          </div>

          <div className="step-item">
            <div className="step-number">3</div>
            <h3>Start Earning</h3>
            <p>Download the driver app, log in, and start accepting ride requests immediately.</p>
          </div>
        </div>
      </section>

      {/* Modern App Download Section */}
      <section className="modern-app-section">
        <div className="section-header">
          <h2>Ready to <span className="blue">Get Started?</span></h2>
          <p>Scan the QR codes below to download our professional apps and start managing your trips efficiently.</p>
        </div>

        <div className="app-download-grid">
          {/* Customer App Card */}
          <div className="modern-app-card">
            <div className="app-badge customer">CUSTOMER APP</div>
            <div className="app-card-content">
              <div className="app-text">
                <h3>CabZigo <span className="blue">Customer</span></h3>
                <p>Request rides, track your driver, and manage payments in one place.</p>
                <div className="download-buttons">
                  <a href="#" className="play-store-link">
                    <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" alt="Google Play" />
                  </a>
                </div>
              </div>
              <div className="qr-box">
                <div className="qr-code-modern">
                    <div className="qr-marker top-left"></div>
                    <div className="qr-marker top-right"></div>
                    <div className="qr-marker bottom-left"></div>
                    <div className="qr-dots-pattern"></div>
                </div>
                <span>Scan for iOS & Android</span>
              </div>
            </div>
          </div>

          {/* Driver App Card */}
          <div className="modern-app-card">
            <div className="app-badge driver">DRIVER APP</div>
            <div className="app-card-content">
              <div className="app-text">
                <h3>CabZigo <span className="blue">Driver</span></h3>
                <p>Accept ride requests, manage earnings, and find the best routes daily.</p>
                <div className="download-buttons">
                  <a href="#" className="play-store-link">
                    <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" alt="Google Play" />
                  </a>
                </div>
              </div>
              <div className="qr-box">
                <div className="qr-code-modern">
                    <div className="qr-marker top-left"></div>
                    <div className="qr-marker top-right"></div>
                    <div className="qr-marker bottom-left"></div>
                    <div className="qr-dots-pattern"></div>
                </div>
                <span>Scan for iOS & Android</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <TestimonialSection 
        title={
          <>
            What Our <span className="blue">Partners</span> Say
          </>
        } 
      />
    </div>
  );
};

export default Drivers;
